export const MESSAGE = {
    SUCCESS: {

    },
    ERROR: {
        LOGIN_FAILED: "Not able to login, Please try again!",
        ACCOUNT_NOT_EXIST: "Account not found. Please contact tech support by raising a FreshService ticket to request access.",
        SESSION_EXPIRED: "Session expired. Please login again. Redirecting...",
        ACCOUNT_DOES_NOT_EXIST: "No Account Service access. Please contact Tech Support via Freshservice to request it.",
    }
}